<template>
    <v-container class="fill-height" fluid style="background-color: gray">
        <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="4">
                <v-card class="elevation-12" color="grey lighten-4">
                    <v-card-text v-if="step === 'successful'">
                        <v-list-item-title class="headline mb-1">Activated</v-list-item-title>
                        <v-list-item-subtitle>Your account is now activated.</v-list-item-subtitle>
                    </v-card-text>
                    <v-card-text v-if="step === 'unsuccessful'">
                        <v-list-item-title class="headline mb-1">Something went wrong</v-list-item-title>
                        <v-list-item-subtitle>There was problem. {{ errorMessage }}</v-list-item-subtitle>
                    </v-card-text>
                    <v-card-text v-if="step === 'ask_password'">
                        <v-list-item-title class="headline mb-1">Create password</v-list-item-title>
                        <v-list-item-subtitle>Insert new password.</v-list-item-subtitle>
                        <v-form v-model="form_validation">
                            <v-text-field
                                id="password"
                                label="Password"
                                name="password"
                                prepend-icon="lock"
                                :rules="[rules.password]"
                                type="password"
                                v-model="password"
                            />

                            <v-text-field
                                id="repeatPassword"
                                label="Repeat password"
                                name="repeatPassword"
                                prepend-icon="lock"
                                :rules="[rules.password]"
                                type="password"
                                v-model="repeat_password"
                            />
                        </v-form>
                        <v-alert v-if="response_error" type="error" color="bal-red">
                            There was problem. {{ response_error }}
                        </v-alert>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            v-if="step === 'ask_password'"
                            :disabled="!form_validation"
                            dark
                            @click="handleCreateClick"
                            >Create</v-btn
                        >
                        <v-btn v-else color="bal-red" dark @click="handleBackClick">Back</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Store from "../store";
import { mapActions } from "vuex";
import router from "../router";
export default {
    name: "activate",
    data() {
        return {
            step: null,
            form_validation: false,
            password: null,
            repeat_password: null,
            response_error: null,
            rules: {
                required: value => !!value || "Required.",
                password: value => {
                    const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#%&])(?=.{8,})/;
                    return (
                        pattern.test(value) ||
                        "Min. 8 characters with at least one capital letter, a number and a special character."
                    );
                }
            }
        };
    },
    async mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        await this.logOutCurrentUser(false);
        let uri = window.location.search.substring(1);
        let params = new URLSearchParams(uri);
        if (params.get("e") && params.get("h")) {
            this.email = params.get("e");
            this.hash = params.get("h");
            let payload = {
                email: this.email,
                hash: this.hash,
                pw: null,
                type: null
            };
            Store.dispatch("checkActivationValidity", payload).then(result => {
                if (result && result.success === 1) {
                    this.step = "ask_password";
                } else {
                    this.response_error = result.msg;
                    this.step = "unsuccessful";
                }
                this.clearUrlFromParameters();
            });
        } else {
            this.clearUrlFromParameters();
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    methods: {
        ...mapActions(["checkActivationValidity", "logOutCurrentUser"]),
        clearUrlFromParameters() {
            this.error = true;
            window.history.replaceState(null, null, window.location.pathname);
        },
        handleBackClick() {
            router.push("/app/login");
        },
        handleCreateClick() {
            this.response_error = null;
            if (this.password !== this.repeat_password || this.password.length < 8) {
                this.response_error = "There was an error in password. ";
            } else {
                let payload = {
                    email: this.email,
                    hash: this.hash,
                    pw: this.password,
                    type: "send-password"
                };
                Store.dispatch("checkActivationValidity", payload).then(result => {
                    if (result && result.success === 1) {
                        router.push("/app/login");
                        Store.commit("setRequestSuccess", true);
                    } else {
                        this.response_error = result.msg;
                        this.step = "unsuccessful";
                    }
                });
            }
        },
        handleKeyboardListener(e) {
            if (e.keyCode === 13) {
                this.handleCreateClick();
            }
        }
    }
};
</script>

<style scoped></style>
